<template>
  <div class="trial-banner">
    <div class="trial-banner-surface" aria-hidden="true"><canvas ref="canvas" class="trial-banner-ascii" /></div>
  </div>
</template>

<script>
export default {
  name: 'TrialBanner',
  data: () => ({ motionState: 'loading' }),
  mounted() {
    import('./ascii-ocean/engine').then(({ OceanEngine }) => {
      if (this._isBeingDestroyed || this._isDestroyed) return;
      this.oceanEngine = new OceanEngine(this.$refs.canvas, state => { this.motionState = state; });
    }).catch(() => { this.motionState = 'unavailable'; });
  },
  beforeDestroy() {
    if (this.oceanEngine) this.oceanEngine.destroy();
  },

};
</script>

<style scoped>
.trial-banner { position: absolute; inset: 0; z-index: auto; overflow: hidden; pointer-events: none; }
.trial-banner-surface { position: absolute; inset: 0; z-index: -1; overflow: hidden; background-color: #3c8acb; background-image: radial-gradient(ellipse 78% 110% at 100% 0%, rgba(209,230,246,.98) 0%, rgba(191,218,241,.72) 29%, rgba(117,173,222,.28) 57%, transparent 83%), radial-gradient(ellipse 60% 70% at 12% 4%, rgba(106,130,213,.24), transparent 78%), linear-gradient(118deg,#4288c9,#3c8acb 48%,#3c8acb); }
.trial-banner-ascii { display: block; position: absolute; inset: 0; width: 100%; height: 100%; opacity: .64; mix-blend-mode: screen; pointer-events: none; -webkit-mask-image: linear-gradient(90deg, rgba(0,0,0,.62), #000 55%); mask-image: linear-gradient(90deg, rgba(0,0,0,.62), #000 55%); }
@media (max-width: 1000px) { .trial-banner-surface { background-image: radial-gradient(ellipse 105% 110% at 108% 0%,rgba(209,230,246,.73),rgba(117,173,222,.26) 49%,transparent 84%),linear-gradient(145deg,#4288c9,#3c8acb 44%); } .trial-banner-ascii { opacity: .48; } }
</style>
